import { render, staticRenderFns } from "./ExaminHeader.vue?vue&type=template&id=94c20a06&scoped=true&"
import script from "./ExaminHeader.vue?vue&type=script&lang=js&"
export * from "./ExaminHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExaminHeader.vue?vue&type=style&index=0&id=94c20a06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c20a06",
  null
  
)

export default component.exports